export const DATE_DISPLAY_FORMAT = 'dd/MM/yyyy'
export const DATE_PARSE_FORMAT = 'dd/MM/yyyy'
export const MYINFO_DATE_FORMAT = 'yyyy-MM-dd'
